import React, { useState, useEffect, useRef } from 'react';
import Sidebar from '../components/Sidebar';
import axios from 'axios';

const API = 'https://app.b3rastreamento.com.br/api';

const fusos = [
  'America/Sao_Paulo', 'America/Manaus', 'America/Belem',
  'America/Fortaleza', 'America/Recife', 'America/Noronha',
  'America/Campo_Grande', 'America/Cuiaba', 'America/Porto_Velho',
  'America/Boa_Vista', 'America/Rio_Branco',
];

const moedas = [
  { value: 'BRL', label: 'R$ — Real Brasileiro' },
  { value: 'USD', label: '$ — Dólar Americano' },
  { value: 'EUR', label: '€ — Euro' },
];

function Configuracoes() {
  const [sidebarAberta, setSidebarAberta] = useState(false);
  const [aba, setAba] = useState('empresa');
  const [salvando, setSalvando] = useState(false);
  const [salvandoSenha, setSalvandoSenha] = useState(false);
  const [config, setConfig] = useState({
    nome: '', logo_url: '', cor_primaria: '#1D9E75',
    email: '', telefone: '', telefone_suporte: '',
    instagram: '', app_android: '', app_ios: '',
    fuso_horario: 'America/Sao_Paulo', moeda: 'BRL',
    sms_gateway_url: '', sms_gateway_login: '',
    sms_gateway_password: '', mostrar_credito: true
  });
  const [senha, setSenha] = useState({ atual: '', nova: '', confirmar: '' });
  const [previewCor, setPreviewCor] = useState('#1D9E75');

  const token = localStorage.getItem('token');
  const usuario = JSON.parse(localStorage.getItem('usuario') || '{}');
  const isSuperadmin = usuario.perfil === 'superadmin';
  const headers = { Authorization: `Bearer ${token}` };

  useEffect(() => { carregarConfig(); }, []);

  const carregarConfig = async () => {
    try {
      const res = await axios.get(`${API}/configuracoes`, { headers });
      setConfig(prev => ({ ...prev, ...res.data }));
      setPreviewCor(res.data.cor_primaria || '#1D9E75');
    } catch (err) { console.error(err); }
  };

  const salvar = async () => {
    setSalvando(true);
    try {
      await axios.put(`${API}/configuracoes`, config, { headers });
      alert('Configurações salvas com sucesso!');
    } catch (err) { alert(err.response?.data?.erro || 'Erro ao salvar'); }
    setSalvando(false);
  };

  const alterarSenha = async () => {
    if (!senha.atual || !senha.nova || !senha.confirmar) { alert('Preencha todos os campos!'); return; }
    if (senha.nova !== senha.confirmar) { alert('Nova senha e confirmação não conferem!'); return; }
    if (senha.nova.length < 6) { alert('Nova senha deve ter pelo menos 6 caracteres!'); return; }
    setSalvandoSenha(true);
    try {
      await axios.patch(`${API}/configuracoes/senha`, { senha_atual: senha.atual, nova_senha: senha.nova }, { headers });
      alert('Senha alterada com sucesso!');
      setSenha({ atual: '', nova: '', confirmar: '' });
    } catch (err) { alert(err.response?.data?.erro || 'Erro ao alterar senha'); }
    setSalvandoSenha(false);
  };

  const inputStyle = { width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '14px', boxSizing: 'border-box' };
  const labelStyle = { fontSize: '12px', color: '#666', fontWeight: '600', display: 'block', marginBottom: '4px' };

  const abas = [
    { key: 'empresa', label: '🏢 Empresa' },
    { key: 'aparencia', label: '🎨 Aparência' },
    { key: 'sistema', label: '🌎 Sistema' },
    ...(isSuperadmin ? [{ key: 'sms', label: '📱 SMS Gateway' }] : []),
    { key: 'seguranca', label: '🔒 Segurança' },
  ];

  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f5' }}>
      <Sidebar aberta={sidebarAberta} setAberta={setSidebarAberta} />

      <div style={{ background: previewCor, padding: '0 24px', height: '60px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'fixed', top: 0, left: 0, right: 0, zIndex: 500, boxShadow: '0 2px 10px rgba(0,0,0,0.2)', transition: 'background .3s' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <button onClick={() => setSidebarAberta(!sidebarAberta)} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '22px', color: 'white' }}>{sidebarAberta ? '✕' : '☰'}</button>
          <span style={{ color: 'white', fontWeight: '700', fontSize: '18px' }}>⚙️ Configurações</span>
        </div>
        <button onClick={salvar} disabled={salvando} style={{ background: 'rgba(255,255,255,0.2)', color: 'white', border: '1px solid rgba(255,255,255,0.4)', borderRadius: '8px', padding: '8px 16px', cursor: salvando ? 'not-allowed' : 'pointer', fontWeight: '600', fontSize: '14px' }}>
          {salvando ? '⏳ Salvando...' : '✅ Salvar Tudo'}
        </button>
      </div>

      <div style={{ marginTop: '60px', padding: '24px' }}>

        <div style={{ display: 'flex', gap: '8px', marginBottom: '20px', background: 'white', borderRadius: '12px', padding: '8px', boxShadow: '0 1px 4px rgba(0,0,0,0.08)' }}>
          {abas.map(a => (
            <button key={a.key} onClick={() => setAba(a.key)} style={{
              background: aba === a.key ? previewCor : 'transparent',
              color: aba === a.key ? 'white' : '#666',
              border: 'none', borderRadius: '8px', padding: '8px 16px',
              cursor: 'pointer', fontWeight: '600', fontSize: '13px', transition: 'all .2s'
            }}>{a.label}</button>
          ))}
        </div>

        {/* EMPRESA */}
        {aba === 'empresa' && (
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '24px' }}>
            <div style={{ background: 'white', borderRadius: '12px', padding: '24px', boxShadow: '0 1px 4px rgba(0,0,0,0.08)' }}>
              <h3 style={{ margin: '0 0 20px', fontSize: '15px', color: '#333' }}>🏢 Dados da Empresa</h3>
              {[
                { label: 'Nome da Empresa', key: 'nome', placeholder: 'Ex: LocTracker' },
                { label: 'Email', key: 'email', placeholder: 'contato@empresa.com' },
                { label: 'Telefone', key: 'telefone', placeholder: '(43) 99999-9999' },
                { label: 'Telefone Suporte', key: 'telefone_suporte', placeholder: '(43) 99999-9999' },
              ].map(f => (
                <div key={f.key} style={{ marginBottom: '14px' }}>
                  <label style={labelStyle}>{f.label}</label>
                  <input type="text" placeholder={f.placeholder} value={config[f.key] || ''}
                    onChange={e => setConfig(prev => ({ ...prev, [f.key]: e.target.value }))}
                    style={inputStyle} />
                </div>
              ))}
            </div>

            <div style={{ background: 'white', borderRadius: '12px', padding: '24px', boxShadow: '0 1px 4px rgba(0,0,0,0.08)' }}>
              <h3 style={{ margin: '0 0 20px', fontSize: '15px', color: '#333' }}>📱 Redes Sociais e App</h3>
              <div style={{ marginBottom: '14px' }}>
                <label style={labelStyle}>Instagram</label>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <span style={{ fontSize: '20px' }}>📸</span>
                  <input type="text" placeholder="@suaempresa" value={config.instagram || ''}
                    onChange={e => setConfig(prev => ({ ...prev, instagram: e.target.value }))}
                    style={inputStyle} />
                </div>
              </div>
              <div style={{ marginBottom: '14px' }}>
                <label style={labelStyle}>Link App Android (Play Store)</label>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <span style={{ fontSize: '20px' }}>🤖</span>
                  <input type="text" placeholder="https://play.google.com/store/apps/..." value={config.app_android || ''}
                    onChange={e => setConfig(prev => ({ ...prev, app_android: e.target.value }))}
                    style={inputStyle} />
                </div>
              </div>
              <div style={{ marginBottom: '14px' }}>
                <label style={labelStyle}>Link App iOS (App Store)</label>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <span style={{ fontSize: '20px' }}>🍎</span>
                  <input type="text" placeholder="https://apps.apple.com/..." value={config.app_ios || ''}
                    onChange={e => setConfig(prev => ({ ...prev, app_ios: e.target.value }))}
                    style={inputStyle} />
                </div>
              </div>

              <div style={{ marginTop: '16px', padding: '14px', background: '#f8f8f8', borderRadius: '10px' }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer' }}>
                  <div onClick={() => setConfig(prev => ({ ...prev, mostrar_credito: !prev.mostrar_credito }))}
                    style={{ width: '36px', height: '20px', borderRadius: '10px', background: config.mostrar_credito ? previewCor : '#ccc', position: 'relative', cursor: 'pointer', transition: 'background .2s', flexShrink: 0 }}>
                    <div style={{ width: '16px', height: '16px', borderRadius: '50%', background: 'white', position: 'absolute', top: '2px', left: config.mostrar_credito ? '18px' : '2px', transition: 'left .2s' }} />
                  </div>
                  <div>
                    <div style={{ fontSize: '13px', fontWeight: '500', color: '#333' }}>Mostrar crédito no rodapé</div>
                    <div style={{ fontSize: '11px', color: '#999' }}>Desenvolvido por Digital Mais BR — digitalmaisbr.com.br</div>
                  </div>
                </label>
              </div>
            </div>
          </div>
        )}

        {/* APARÊNCIA */}
        {aba === 'aparencia' && (
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '24px' }}>
            <div style={{ background: 'white', borderRadius: '12px', padding: '24px', boxShadow: '0 1px 4px rgba(0,0,0,0.08)' }}>
              <h3 style={{ margin: '0 0 20px', fontSize: '15px', color: '#333' }}>🎨 Identidade Visual</h3>

              <div style={{ marginBottom: '20px' }}>
                <label style={labelStyle}>Cor Primária</label>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <input type="color" value={config.cor_primaria || '#1D9E75'}
                    onChange={e => { setConfig(prev => ({ ...prev, cor_primaria: e.target.value })); setPreviewCor(e.target.value); }}
                    style={{ width: '48px', height: '48px', borderRadius: '8px', border: 'none', cursor: 'pointer', padding: '2px' }} />
                  <input type="text" value={config.cor_primaria || '#1D9E75'}
                    onChange={e => { setConfig(prev => ({ ...prev, cor_primaria: e.target.value })); setPreviewCor(e.target.value); }}
                    style={{ ...inputStyle, width: '140px' }} />
                  <div style={{ fontSize: '12px', color: '#999' }}>A barra do topo muda em tempo real!</div>
                </div>
                <div style={{ display: 'flex', gap: '8px', marginTop: '12px', flexWrap: 'wrap' }}>
                  {['#1D9E75', '#2563EB', '#7C3AED', '#DC2626', '#D97706', '#0891B2', '#BE185D', '#1a1a2e'].map(cor => (
                    <div key={cor} onClick={() => { setConfig(prev => ({ ...prev, cor_primaria: cor })); setPreviewCor(cor); }}
                      style={{ width: '28px', height: '28px', borderRadius: '6px', background: cor, cursor: 'pointer', border: config.cor_primaria === cor ? '3px solid #333' : '2px solid transparent', transition: 'border .1s' }} />
                  ))}
                </div>
              </div>

              <div style={{ marginBottom: '14px' }}>
                <label style={labelStyle}>URL da Logo</label>
                <input type="text" placeholder="https://suaempresa.com/logo.png" value={config.logo_url || ''}
                  onChange={e => setConfig(prev => ({ ...prev, logo_url: e.target.value }))}
                  style={inputStyle} />
                <div style={{ fontSize: '11px', color: '#999', marginTop: '4px' }}>Use um link direto para a imagem (PNG ou SVG recomendado)</div>
              </div>
            </div>

            <div style={{ background: 'white', borderRadius: '12px', padding: '24px', boxShadow: '0 1px 4px rgba(0,0,0,0.08)' }}>
              <h3 style={{ margin: '0 0 20px', fontSize: '15px', color: '#333' }}>👁️ Preview</h3>
              <div style={{ borderRadius: '10px', overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.15)', marginBottom: '16px' }}>
                <div style={{ background: previewCor, padding: '12px 16px', display: 'flex', alignItems: 'center', gap: '12px' }}>
                  {config.logo_url ? (
                    <img src={config.logo_url} alt="logo" style={{ height: '28px', objectFit: 'contain' }} onError={e => e.target.style.display = 'none'} />
                  ) : (
                    <span style={{ color: 'white', fontWeight: '700', fontSize: '16px' }}>🛰️ {config.nome || 'Sua Empresa'}</span>
                  )}
                </div>
                <div style={{ background: '#f8f8f8', padding: '12px 16px', fontSize: '12px', color: '#666' }}>
                  Dashboard · Clientes · Equipamentos · Targets
                </div>
              </div>
              <div style={{ borderRadius: '10px', overflow: 'hidden', border: '1px solid #eee' }}>
                <div style={{ background: previewCor, padding: '12px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span style={{ color: 'white', fontWeight: '700' }}>{config.nome || 'Sua Empresa'}</span>
                  <span style={{ color: 'rgba(255,255,255,0.8)', fontSize: '11px' }}>Relatório de Rota</span>
                </div>
                <div style={{ padding: '12px 16px', fontSize: '12px', color: '#666', background: 'white' }}>
                  Veículo: HSY-6I69 · Distância: 8.39 km
                </div>
                {config.mostrar_credito && (
                  <div style={{ padding: '8px 16px', background: '#f8f8f8', fontSize: '10px', color: '#999', textAlign: 'center' }}>
                    Desenvolvido por Digital Mais BR — digitalmaisbr.com.br
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {/* SISTEMA */}
        {aba === 'sistema' && (
          <div style={{ background: 'white', borderRadius: '12px', padding: '24px', boxShadow: '0 1px 4px rgba(0,0,0,0.08)', maxWidth: '600px' }}>
            <h3 style={{ margin: '0 0 20px', fontSize: '15px', color: '#333' }}>🌎 Configurações do Sistema</h3>
            <div style={{ marginBottom: '14px' }}>
              <label style={labelStyle}>Fuso Horário</label>
              <select value={config.fuso_horario || 'America/Sao_Paulo'}
                onChange={e => setConfig(prev => ({ ...prev, fuso_horario: e.target.value }))}
                style={{ ...inputStyle, background: 'white' }}>
                {fusos.map(f => <option key={f} value={f}>{f}</option>)}
              </select>
            </div>
            <div style={{ marginBottom: '14px' }}>
              <label style={labelStyle}>Moeda</label>
              <select value={config.moeda || 'BRL'}
                onChange={e => setConfig(prev => ({ ...prev, moeda: e.target.value }))}
                style={{ ...inputStyle, background: 'white' }}>
                {moedas.map(m => <option key={m.value} value={m.value}>{m.label}</option>)}
              </select>
            </div>
            <div style={{ background: '#f8f8f8', borderRadius: '10px', padding: '14px', fontSize: '13px', color: '#666' }}>
              ℹ️ O fuso horário afeta a exibição de datas e horários em todo o sistema, incluindo relatórios e alertas.
            </div>
          </div>
        )}

        {/* SMS GATEWAY — apenas superadmin */}
        {aba === 'sms' && isSuperadmin && (
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '24px' }}>
            <div style={{ background: 'white', borderRadius: '12px', padding: '24px', boxShadow: '0 1px 4px rgba(0,0,0,0.08)' }}>
              <h3 style={{ margin: '0 0 8px', fontSize: '15px', color: '#333' }}>📱 Android SMS Gateway</h3>
              <p style={{ fontSize: '13px', color: '#666', marginBottom: '20px', marginTop: 0 }}>
                Este celular enviará os SMS de bloqueio/desbloqueio para <strong>todos os rastreadores</strong> de todos os clientes da plataforma.
              </p>
              {[
                { label: 'URL do Gateway', key: 'sms_gateway_url', placeholder: 'http://192.168.0.100:8080/message', type: 'text' },
                { label: 'Login', key: 'sms_gateway_login', placeholder: 'admin', type: 'text' },
                { label: 'Senha', key: 'sms_gateway_password', placeholder: '••••••••', type: 'password' },
              ].map(f => (
                <div key={f.key} style={{ marginBottom: '14px' }}>
                  <label style={labelStyle}>{f.label}</label>
                  <input type={f.type} placeholder={f.placeholder} value={config[f.key] || ''}
                    onChange={e => setConfig(prev => ({ ...prev, [f.key]: e.target.value }))}
                    style={inputStyle} />
                </div>
              ))}
              <button onClick={async () => {
                try {
                  await axios.post(`${API}/configuracoes/testar-sms`, { url: config.sms_gateway_url, login: config.sms_gateway_login, password: config.sms_gateway_password }, { headers });
                  alert('✅ Gateway SMS conectado com sucesso!');
                } catch {
                  alert('❌ Não foi possível conectar ao gateway SMS. Verifique as configurações.');
                }
              }} style={{ width: '100%', background: '#E6F1FB', color: '#185FA5', border: 'none', borderRadius: '8px', padding: '10px', cursor: 'pointer', fontWeight: '600', fontSize: '13px', marginTop: '8px' }}>
                🔍 Testar Conexão
              </button>
            </div>

            <div style={{ background: 'white', borderRadius: '12px', padding: '24px', boxShadow: '0 1px 4px rgba(0,0,0,0.08)' }}>
              <h3 style={{ margin: '0 0 16px', fontSize: '15px', color: '#333' }}>📋 Como configurar</h3>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
                {[
                  { num: '1', texto: 'Instale o app "SMS Gateway for Android" na Play Store no celular dedicado' },
                  { num: '2', texto: 'Abra o app e anote o IP e porta exibidos (ex: 192.168.0.100:8080)' },
                  { num: '3', texto: 'Configure login e senha no app (padrão: admin/admin)' },
                  { num: '4', texto: 'Cole as informações nos campos ao lado e clique em Salvar Tudo' },
                  { num: '5', texto: 'Desative a otimização de bateria para o app nas configurações do Android' },
                ].map((p, i) => (
                  <div key={i} style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
                    <div style={{ width: '24px', height: '24px', borderRadius: '50%', background: previewCor, color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', fontWeight: '700', flexShrink: 0 }}>{p.num}</div>
                    <div style={{ fontSize: '13px', color: '#666', lineHeight: '1.5' }}>{p.texto}</div>
                  </div>
                ))}
                <div style={{ background: '#FAEEDA', borderRadius: '8px', padding: '12px', fontSize: '12px', color: '#633806' }}>
                  ⚠️ O celular precisa estar ligado 24h. Este gateway é compartilhado entre todos os clientes da plataforma.
                </div>
              </div>
            </div>
          </div>
        )}

        {/* SEGURANÇA */}
        {aba === 'seguranca' && (
          <div style={{ background: 'white', borderRadius: '12px', padding: '24px', boxShadow: '0 1px 4px rgba(0,0,0,0.08)', maxWidth: '500px' }}>
            <h3 style={{ margin: '0 0 20px', fontSize: '15px', color: '#333' }}>🔒 Alterar Senha</h3>
            {[
              { label: 'Senha Atual', key: 'atual', placeholder: '••••••••' },
              { label: 'Nova Senha', key: 'nova', placeholder: 'Mínimo 6 caracteres' },
              { label: 'Confirmar Nova Senha', key: 'confirmar', placeholder: 'Repita a nova senha' },
            ].map(f => (
              <div key={f.key} style={{ marginBottom: '14px' }}>
                <label style={labelStyle}>{f.label}</label>
                <input type="password" placeholder={f.placeholder} value={senha[f.key]}
                  onChange={e => setSenha(prev => ({ ...prev, [f.key]: e.target.value }))}
                  style={inputStyle} />
              </div>
            ))}
            {senha.nova && senha.confirmar && senha.nova !== senha.confirmar && (
              <div style={{ background: '#FCEBEB', color: '#A32D2D', padding: '10px', borderRadius: '8px', fontSize: '13px', marginBottom: '14px' }}>❌ As senhas não conferem</div>
            )}
            {senha.nova && senha.nova === senha.confirmar && senha.nova.length >= 6 && (
              <div style={{ background: '#E1F5EE', color: '#0F6E56', padding: '10px', borderRadius: '8px', fontSize: '13px', marginBottom: '14px' }}>✅ Senhas conferem</div>
            )}
            <button onClick={alterarSenha} disabled={salvandoSenha} style={{ width: '100%', background: salvandoSenha ? '#ccc' : '#1D9E75', color: 'white', border: 'none', borderRadius: '8px', padding: '12px', cursor: salvandoSenha ? 'not-allowed' : 'pointer', fontWeight: '600', fontSize: '14px' }}>
              {salvandoSenha ? '⏳ Alterando...' : '🔒 Alterar Senha'}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default Configuracoes;